import React from 'react'
import { ReactComponent as Logo }from '../assets/page.svg'
const Missing = () => {
  return (
    <main className='Missing'>
      <Logo/>
    </main>
  )
}

export default Missing